import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GoogleMapsLoaderService } from './services/google-maps-loader.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    private readonly _googleMapsLoader = inject(GoogleMapsLoaderService);

    constructor() {}

    ngOnInit(): void {
        this._googleMapsLoader.load();
    }
}
